<template>
  <div>
    <Header pageTitle="المهن" style="direction: rtl;" />
    <div class="container mb-4" style="padding-top: 70px;">
      <div v-if="isLoading" class="loading-overlay">
        <div class="spinner"></div>
      </div>
      <div v-else class="row g-3 mb-4">
        <div class="col-6 col-lg-3" v-for="category in categories" :key="category.categories_id">
          <div class="card">
            <router-link :to="{ name: 'professionsDetailsPage', params: { id: category.categories_id } }">
              <div class="avatar-circle" :style="{ backgroundColor: category.categories_color }">
                <component :is="icons[category.categories_icon] || getCategoryIcon(category.categories_icon)" :style="{
                  color: '#fff',
                  width: '30px',
                  height: '30px'
                }" />
              </div>
              <div class="hstack mt-3 text-center">
                <h6 class="mb-0">
                  <a href="#!">{{ category.categories_name }}</a>
                </h6>
              </div>
            </router-link>
          </div>
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import { ref, onMounted } from "vue";
import axios from "axios";
import Header from "../../components/header.vue";
import Footer from "../../components/footer.vue";
import * as HeroIcons from "@heroicons/vue/24/outline";
import { QuestionMarkCircleIcon } from "@heroicons/vue/24/outline";

export default {
  name: "ProfessionPage",
  components: {
    Header,
    Footer,
  },
  setup() {
    const categories = ref([]);
    const isLoading = ref(true);
    const icons = ref({});

    const loadIcon = async (iconName) => {
      try {
        const module = await import(`@heroicons/vue/24/solid/${iconName}Icon.js`);
        return module.default;
      } catch (error) {
        console.warn(`Icon not found: ${iconName}`);
        return null;
      }
    };

    const fetchCategories = async () => {
      try {
        // تحقق مما إذا كانت البيانات مخزنة في localStorage
        const cachedData = localStorage.getItem('cachedCategoriesData');
        if (cachedData) {
          const parsedData = JSON.parse(cachedData);
          categories.value = parsedData.categories;
          icons.value = parsedData.icons;
          isLoading.value = false;
        } else {
          // إذا لم تكن البيانات موجودة، قم بجلبها من الخادم
          const response = await axios.get("https://zadcodeonline.com/ahmad/etqan/backEnd/categories/view.php");
          if (response.data.status === "success") {
            categories.value = response.data.data;

            for (const category of categories.value) {
              const icon = await loadIcon(category.categories_icon);
              if (icon) {
                icons.value[category.categories_icon] = icon;
              }
            }

            // حفظ البيانات في localStorage
            localStorage.setItem('cachedCategoriesData', JSON.stringify({
              categories: categories.value,
              icons: icons.value,
            }));
          } else {
            console.error("Failed to fetch categories");
          }
        }
      } catch (error) {
        console.error("Error fetching categories:", error);
      } finally {
        isLoading.value = false;
      }
    };

    onMounted(fetchCategories);

    return {
      categories,
      isLoading,
      icons,
    };
  },
  methods: {
    getCategoryIcon(iconName) {
      if (!iconName) return QuestionMarkCircleIcon;

      if (iconName.includes(".")) {
        iconName = iconName.split(".").pop();
      }

      const formattedName =
        iconName.charAt(0).toUpperCase() + iconName.slice(1) + "Icon";

      return HeroIcons[formattedName] || QuestionMarkCircleIcon;
    },
  },
};
</script>

<style scoped>
.card {
  background-color: #f8f9fa;
  border-radius: 15px;
  padding: 15px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  text-align: center;
  transition: transform 0.3s ease;
}

.card:hover {
  transform: scale(1.05);
}

.avatar-circle {
  width: 80px;
  height: 80px;
  background-color: #f0f0f0;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 auto;
}

.hstack {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(255, 255, 255, 0.8);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.spinner {
  border: 4px solid #f3f3f3;
  border-top: 4px solid #3498db;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}
</style>